import React from "react";
import { Download, Clock } from "lucide-react";
import { LearnHeader, Markdown, PrevNext, Sources, absUrl, HANDLE } from "@/components/learn/common";
import { useLearnItem, LearnFrame, LearnFooter } from "@/pages/learn/LearnFrame";
import { useHead } from "@/lib/useHead";

function PdfBox({ item }) {
  if (item.is_paid) {
    return (
      <div className="flex flex-wrap items-center justify-between gap-3 rounded-[10px] border border-border bg-card p-5" data-testid="learn-guide-paid">
        <p className="font-heading font-bold text-ink">The full guide (PDF)</p>
        <span className="inline-flex items-center gap-1.5 rounded-lg border border-border px-4 py-2.5 text-sm font-semibold text-muted" data-testid="learn-guide-coming-soon"><Clock className="h-4 w-4" /> Coming soon</span>
      </div>
    );
  }
  if (!item.pdf_url) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-[10px] border border-border bg-card p-5" data-testid="learn-guide-pdf">
      <div>
        <p className="font-heading font-bold text-ink">Download the guide</p>
        <p className="text-sm text-muted">Free PDF. No sign-up needed.</p>
      </div>
      <a href={item.pdf_url} target="_blank" rel="noopener noreferrer" download data-testid="learn-guide-download"
        className="inline-flex items-center gap-2 rounded-lg bg-accent px-5 py-3 text-sm font-semibold text-white transition-opacity hover:opacity-90">
        <Download className="h-4 w-4" /> Download PDF
      </a>
    </div>
  );
}

function Guide({ data }) {
  const { item, previous, next } = data;
  const url = absUrl(item.path);
  const image = absUrl(item.cover_url);
  useHead({
    title: `${item.title} — ${HANDLE}`, description: item.summary || item.title, image, url, type: "article",
    jsonLd: { "@context": "https://schema.org", "@type": "Article", headline: item.title, description: item.summary || undefined,
      image: image ? [image] : undefined, datePublished: item.publish_at, mainEntityOfPage: url, author: { "@type": "Person", name: "Shubham Bapna" } },
  });
  return (
    <article className="mx-auto max-w-[760px] space-y-10 px-5 py-12" data-testid="learn-guide-page">
      <LearnHeader item={item} kicker={item.is_paid ? "Guide" : "Free guide"} />
      <PdfBox item={item} />
      {item.body_md && <Markdown testid="learn-body">{item.body_md}</Markdown>}
      <Sources sources={item.sources} />
      <LearnFooter item={item} url={url} />
      <PrevNext previous={previous} next={next} prefix="g" label="guide" />
    </article>
  );
}

export default function LearnGuide() {
  const q = useLearnItem("guide");
  return <LearnFrame query={q}>{(data) => <Guide data={data} />}</LearnFrame>;
}
